<template>
	<div id="set">
		<userMenu></userMenu>
		<div class="set-wrap">
			<div class="set-item" style="display: none;">
				<el-input v-model="account" :readonly="true">
					<template slot="prepend">账号</template>
				</el-input>
			</div>
			<div class="set-item" style="width: 300px;margin: 20px;">
				<div class="set-mypic">
					<img :src="avatar" v-if="avatar">
				</div>
				<div class="set-pics">
					<div :class="selectIndex==index?'set-picss picon':'set-picss'" v-for="(item,index) in pics" @click="selectImg(index)">
						<img :src="item">
						<div class="set-select">
							<i class="el-icon-success"></i>
						</div>
					</div>
				</div>
			</div>
			<div class="set-item" style="margin: 20px 20px 20px 0;flex: 1;">
				<el-input class="mgt20" v-model="nickname" maxlength="10" show-word-limit>
					<template slot="prepend">昵称</template>
				</el-input>
				<el-input class="mgt20" v-model="wechat">
					<template slot="prepend">微信</template>
				</el-input>
				<el-input class="mgt20" v-model="email">
					<template slot="prepend">邮箱</template>
				</el-input>
				<el-input class="mgt20" v-model="phone" maxlength="11" show-word-limit>
					<template slot="prepend">电话</template>
				</el-input>
				<div class="set-tip">
					* 完善基本信息，可用于忘记账号或密码时找回。
				</div>
				<div class="set-btn">
					<el-button type="primary"  style="width: 200px;" @click="save">立即保存</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import userMenu from '@/page/public/userMenu'
	import api from '@/api/api'
	export default {
		components: {
			userMenu: userMenu
		},
		data() {
			return {
				selectIndex:15,
				pics:[
					'http://www.beiyv.com/upload/ai/26/2.jpg',
					'http://www.beiyv.com/upload/ai/26/4.jpg',
					'http://www.beiyv.com/upload/ai/26/5.jpg',
					'http://www.beiyv.com/upload/ai/26/7.jpg',
					'http://www.beiyv.com/upload/ai/26/10.jpg',
					'http://www.beiyv.com/upload/ai/26/14.jpg',
					'http://www.beiyv.com/upload/ai/26/15.jpg',
					'http://www.beiyv.com/upload/ai/26/19.jpg',
					'http://www.beiyv.com/upload/ai/26/20.jpg',
					'http://www.beiyv.com/upload/ai/26/21.jpg',
					'http://www.beiyv.com/upload/ai/26/23.jpg',
					'http://www.beiyv.com/upload/ai/26/24.jpg',
					'http://www.beiyv.com/upload/ai/26/54.jpg',
					'http://www.beiyv.com/upload/ai/26/53.jpg',
					'http://www.beiyv.com/upload/ai/26/49.jpg',
					'http://www.beiyv.com/upload/ai/26/36.jpg',
					'http://www.beiyv.com/upload/ai/26/41.jpg',
					'http://www.beiyv.com/upload/ai/26/48.jpg',
					'http://www.beiyv.com/upload/ai/26/22.jpg',
					'http://www.beiyv.com/upload/ai/26/40.jpg',
					'http://www.beiyv.com/upload/ai/26/43.jpg'
				],
				account:'',
				avatar:'',
				email:'',
				nickname:'',
				phone:'',
				wechat:''
			}
		},
		methods:{
			save(){
				if(this.nickname == ''){
					this.$message.error('请输入昵称');
					return
				}
				let params = {
					token: api.getCookie('token'),
					nickName: this.nickname,
					avatar:this.avatar
				}
				if(this.wechat){
					params.wechat = this.wechat;
				}
				if(this.phone){
					params.phone = this.phone;
				}
				if(this.email){
					params.email = this.email;
				}
				api.setUserInfo(params).then(res=>{
					if(res.code == 200){
						this.getMemberInfo;
						this.$message.success('保存成功')
					}else{
						this.$message.error(res.msg)
					}
				})
			},
			getMemberInfo() {
				let params = {
					token: api.getCookie('token')
				}
				api.getMemberInfo(params).then(res => {
					if (res.code == 200) {
						this.account = res.data.account;
						this.email = res.data.email;
						this.nickname = res.data.nickname;
						this.phone = res.data.phone;
						this.wechat = res.data.wechat;
						if(res.data.avatar){
							this.avatar = res.data.avatar;
							for(let i in this.pics){
								if(res.data.avatar == this.pics[i]){
									this.selectIndex = i;
								}
							}
						}else{
							this.avatar = this.pics[15];
							this.selectIndex = 15;
						}
					}
				})
			},
			selectImg(index){
				this.selectIndex = index;
				this.avatar = this.pics[index];
			}
		},
		created() {
			this.getMemberInfo()
		}
	}
</script>

<style>
	.set-btn{
		text-align: center;
		padding: 20px 0;
	}
	.set-tip{
		font-size: 12px;
		color: #999;
		margin-bottom: 20px;
	}
	.mgt20{
		margin-bottom: 20px;
	}
	.set-item{
		background-color: #fff;
		border-radius: 10px;
		box-sizing: border-box;
		margin-bottom: 20px;
		padding: 30px;
	}
	.set-pics{
		flex: 1;
		display: flex;
		flex-wrap: wrap;
		overflow: hidden;
	}
	.set-picss{
		position: relative;
		width: 70px;
		height: 70px;
		margin:5px;
		border-radius: 10px;
		overflow: hidden;
		background-color: var(--bg);
	}
	.set-select{
		display: none;
		position: absolute;
		top: 5px;
		right: 5px;
		color: var(--color);
	}
	.picon .set-select{
		display: block;
	}
	.set-picss img{
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		opacity: .5;
	}
	.picon img,.set-picss:hover img{
		opacity: 1;
	}
	.set-mypic{
		width: 240px;
		height: 240px;
		border-radius: 10%;
		overflow: hidden;
		margin-bottom: 10px;
		background-color: var(--bg);
	}
	.set-mypic img{
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.flex{
		display: flex;
	}
	.set-wrap{
		display: flex;
		position: relative;
		width: 100%;
		box-sizing: border-box;
		padding-left: 220px;
	}
	#set{
		width: 100%;
		padding-bottom: 30px;
		min-height: 100vh;
		box-sizing: border-box;
		background-color: var(--bg3);
	}
</style>



// WEBPACK FOOTER //
// src/page/set.vue